export default {
  保存: "保存",
  取消: "取消",
  确认: "確認",
  确定: "確定",
  删除: "刪除",
  编辑: "編輯",
  新增: "新增",
  搜索: "搜索",
  查询: "查詢",
  重置: "重置",
  展开: "展開",
  收起: "收起",
  是: "是",
  否: "否",
  操作: "操作",
  查看: "查看",
  关闭: "關閉",
  暂存: "暫存",
  提交: "提交",
  点击选择供应商: "點擊選擇供應商",
  点击上传: "點擊上傳",
  文件上传失败: "文件上傳失敗",
};
